<template>
    <app-container class="message-board-page">
        <search-header :total="total"/>
        <message-board-comment @get-success="handleGetSuccess"/>
        <message-board-skeleton v-if="total===0"/>
    </app-container>
</template>

<script>
    import AppContainer from '@components/AppContainer'
    import SearchHeader from './components/Header'
    import MessageBoardComment from './components/MessageBoardComment'
    import MessageBoardSkeleton from '@assets/svg/inline.message-board-skeleton.svg'

    export default {
        name: "MessageBoard",
        data() {
            return {
                total: 0
            }
        },
        methods: {
            handleGetSuccess({total}) {
                this.total = total || 0
            }
        },
        components: {
            SearchHeader,
            AppContainer,
            MessageBoardComment,
            MessageBoardSkeleton
        }
    }
</script>

<style lang="scss">
    @import "@assets/styles/varibles.scss";

    .message-board-page {
        padding: $paddingSP*2 $paddingMD $paddingSP;
        max-width: 800px;
    }
</style>